import { createFileRoute } from '@tanstack/react-router'
import UserAdminPage from '@/pages/UserAdminPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/admin/users/$userid')({
    component: UserAdminPage,
})